<script setup>
import DropdownWrapper from '@/components/shared/dropdown/DropdownWrapper.vue'
import Dropdown from '@/components/shared/dropdown/Dropdown.vue'
import DropdownMenu from '@/components/shared/dropdown/DropdownMenu.vue'
import DropdownMenuItem from '@/components/shared/dropdown/DropdownMenuItem.vue'
import ActionButton from '@/components/shared/buttons/ActionButton.vue'
import AppThemeToggle from '@/components/app/AppThemeToggle.vue'
import {openUrl} from '@/helpers/url.js'
import {useVisibilityToggle} from '@/composables/use-visibility-toggle.js'
import {useEmptySlotsCheck} from '@/composables/use-empty-slots-check.js'
import {useTeams} from '@/composables/use-teams.js'
import {useNavigation} from '@/composables/use-navigation.js'
import {useCurrentOrganization} from '@/composables/use-current-organization.js'
import {ref, computed, watchEffect} from 'vue'

//Emits and props
const emit = defineEmits([
  'open',
  'close',
])

//Composables
const {isInTeams} = useTeams()
const {goToEnroll} = useNavigation()
const {
  showEnrollMenuItem,
  showHelpMenuItem,
  showFeedbackMenuItem,
  feedbackUrl,
} = useCurrentOrganization()

//Check if there are any actions
const {isSlotEmpty} = useEmptySlotsCheck()
const hasActions = computed(() => (
  !isSlotEmpty.value ||
  showEnrollMenuItem.value ||
  showFeedbackMenuItem.value ||
  showHelpMenuItem.value ||
  !isInTeams.value
))

//Dropdown toggling
const wrapper = ref(null)
const menu = ref(null)
const {
  isVisible,
  toggle,
  hide,
} = useVisibilityToggle(wrapper)

//Watch open state
watchEffect(() => {
  if (isVisible.value) {
    emit('open')
  }
  else {
    emit('close')
  }
})
</script>

<template>
  <DropdownWrapper
    v-if="hasActions"
    ref="wrapper"
  >
    <ActionButton
      type="secondary"
      icon="more_horiz"
      @click.stop="toggle()"
    />
    <Dropdown
      alignment="right"
      :class="$style.dropdown"
      :is-visible="isVisible"
    >
      <DropdownMenu
        ref="menu"
        @click.stop="hide()"
      >
        <slot />
        <DropdownMenuItem
          v-if="showEnrollMenuItem"
          label="Enroll"
          icon="add"
          @click="goToEnroll()"
        />
        <DropdownMenuItem
          v-if="showFeedbackMenuItem && feedbackUrl"
          label="Submit feedback"
          icon="chat"
          @click="openUrl(feedbackUrl, null, true)"
        />
        <DropdownMenuItem
          v-if="showHelpMenuItem"
          label="Help"
          icon="contact_support"
          @click="openUrl('https://help.arist.co/category/117-support-for-learners', null, true)"
        />
        <AppThemeToggle v-if="!isInTeams" />
      </DropdownMenu>
    </Dropdown>
  </DropdownWrapper>
</template>

<style module lang="scss">
.dropdown {
  margin-top: 0.5rem;
  margin-right: 0.5rem;
  box-shadow: var(--box-shadow-strong);
}
</style>
